import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from 'components/InputField';

let CustomPlanPricingFilters = ({ handleSubmit, onResetFilters }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          columnGap: '30px',
        }}
      >
        <Field
          component={InputField}
          name="user_profile"
          label="User Profile ID"
        />
        <Field component={InputField} name="att_plan" label="AT&T Plan ID" />
        <Field component={InputField} name="simo_plan" label="Simo Plan ID" />
        <Field component={InputField} name="quick_plan" label="Quick Plan ID" />
      </div>
      <div className="d-flex">
        <div>
          <div className="d-flex">
            <span style={{ marginRight: 'auto' }}>Visible:</span>
            <label style={{ cursor: 'pointer' }} className="mar-r mar-l">
              <Field
                component="input"
                type="radio"
                value="true"
                name="is_visible"
              />
              &nbsp;Yes
            </label>
            <label style={{ cursor: 'pointer' }}>
              <Field
                component="input"
                type="radio"
                value="false"
                name="is_visible"
              />
              &nbsp;No
            </label>
          </div>
          <div className="d-flex">
            <span style={{ marginRight: 'auto' }}>Effective:</span>
            <label style={{ cursor: 'pointer' }} className="mar-r mar-l">
              <Field
                component="input"
                type="radio"
                value="true"
                name="is_effective"
              />
              &nbsp;Yes
            </label>
            <label style={{ cursor: 'pointer' }}>
              <Field
                component="input"
                type="radio"
                value="false"
                name="is_effective"
              />
              &nbsp;No
            </label>
          </div>
        </div>
        <div className="mar-l" style={{ alignSelf: 'flex-end' }}>
          <button className="btn btn-primary mar-r" type="submit">
            Filter
          </button>
          <button
            className="btn btn-default"
            type="button"
            onClick={onResetFilters}
          >
            Reset
          </button>
        </div>
      </div>
    </form>
  );
};

CustomPlanPricingFilters = reduxForm({
  form: 'customPlanPricingFilters',
  enableReinitialize: true,
})(CustomPlanPricingFilters);

export default CustomPlanPricingFilters;
